<div class="container-fluid">
  <form [formGroup]="form" novalidate>
    <div class="row mb-3">
      <div class="col-md-6">
        <div class="form-group">
          <label for="programa">Programa</label>
          <br-select-custom
            id="programa"
            formControlName="programa"
            ngDefaultControl
            placeholder="Selecione"
            [options]="comboProgramas()"
            [class.placeholder-like]="isSelectPlaceholder('programa')"
            (ngModelChange)="onChangePrograma($event)"
          ></br-select-custom>
        </div>
      </div>
      @if (selectedProgramaId) {
        <div class="col-md-6">
          <div class="form-group">
            <label for="ciclo">Ciclo do Edital</label>
            <br-select-custom
              id="ciclo"
              formControlName="ciclo"
              ngDefaultControl
              placeholder="Selecione"
              [options]="comboCiclos()"
              [class.placeholder-like]="isSelectPlaceholder('ciclo')"
              (ngModelChange)="onChangeCiclo($event)"
            ></br-select-custom>
          </div>
        </div>
      }
    </div>
  </form>

  @if (cicloSelected?.confirmacaoVaga) {
    <div class="alert alert-info mt-2" role="alert">
      <i class="fas fa-info-circle me-1"></i>
      <strong>Período de confirmação aberto: {{ cicloSelected?.confirmacaoVaga?.inicioFormatado }} a {{ cicloSelected?.confirmacaoVaga?.fimFormatado }}</strong>
      — você poderá editar as informações até o encerramento deste período.
    </div>
  }

  @if (cicloSelected && mensagemPrazoBloqueado) {
    <div class="alert alert-warning mt-2" role="alert">
      <i class="fas fa-exclamation-triangle me-1"></i>
      <strong>{{ mensagemPrazoBloqueado }}</strong>
    </div>
  }

  @if (cicloSelected && tipoProvisionamento === 1) {
    <app-confirmacao-vaga-tipo-equipe
      [cicloSelected]="cicloSelected"
      [usuario]="usuario"
      [municipio]="municipio"
    ></app-confirmacao-vaga-tipo-equipe>
  }

  @if (cicloSelected && tipoProvisionamento === 2) {
    <app-confirmacao-vaga-aprimoramento
      [cicloSelected]="cicloSelected"
      [usuario]="usuario"
      [municipio]="municipio"
      [uf]="uf"
    ></app-confirmacao-vaga-aprimoramento>
  }
</div>
